import { PaletteColor, Theme } from "@mui/material/styles";

export const getPaleteColor = (theme: Theme, color?: string) => {
  const paleteColor = color;

  if (color && typeof color === "string" && color?.includes(".")) {
    const [paletteName, colorKey] = color.split(".");
    const palette = theme.palette[paletteName as keyof typeof theme.palette] as PaletteColor | undefined;

    if (palette && typeof palette === "object" && colorKey in palette) {
      return palette[colorKey as keyof PaletteColor];
    }
  } else if (color && color !== "none") {
    const palette = theme.palette[color as keyof typeof theme.palette] as PaletteColor | undefined;

    if (palette && typeof palette === "object" && "main" in palette) {
      return palette.main;
    }
  }

  return paleteColor;
};
